import { MapWidgetEvent, WidgetState } from '../api'

export const mapWidgetReducer: WidgetReducerType<WidgetState, FlowMessage<MapWidgetEvent>> = (
    state = { batch: [] },
    message
) => {
    if (message?.type === 'start') {
        return {
            ...state,
            meta: message.events.info
        }
    }
    if (message?.type === 'event') {
        return {
            ...state,
            batch: message.events
        }
    }

    return state
}
